import React, { useEffect } from "react";
import AppState from "./common/StateMachine/AppState";
import { Route, Router, Switch } from "react-router";

import ToastProvider from "./common/ToastProvider/ToastProvider";
import mustBeLoggedIn from "./common/account/mustBeLoggedIn";
import useRouter from "./common/useRouter/useRouter";
import PlastXProvider from "./components/PlastXProvider/PlastXProvider";
import Notfound from "./common/404/Notfound";
import useAccount from "./common/account/hooks/useAccount";
import useJobs from "./stateHooks/useJobs";
import createBrowserHistory from "history/es/createBrowserHistory";
import Home from "./components/Home/Home";
import Jobs from "./components/Jobs/Jobs";
import Profile from "./components/Profile/Profile";
import JobDetails from "./components/Jobs/JobDetails";
import JobCommit from "./components/Jobs/JobCommit";
import JobDelivery from "./components/Jobs/JobDelivery";
import Impersonate from "./common/account/components/Impersonate/Impersonate";
import Unimpersonate from "./common/account/components/Unimpersonate/Unimpersonate";
import AccountWrapper from "./common/account/components/AccountWrapper";
import ForgotPassword from "./common/account/components/ForgotPassword/ForgotPassword";
import QrCode from "./components/Profile/QrCode";
import EditProfile from "./components/Profile/EditProfile";
import HubInQualityCheck from "./components/QualityCheck/HubInQualityCheck";
import HubOutQualityCheck from "./components/QualityCheck/HubOutQualityCheck";
import CollectorQualityCheck from "./components/QualityCheck/CollectorQualityCheck";
import ProcessorQualityCheck from "./components/QualityCheck/ProcessorQualityCheck";

import "./app.scss";
import AccountProvider from "./common/AccountProvider/AccountProvider";
import { useTranslation } from "react-i18next";

const history = createBrowserHistory();

const containers = {
    router: useRouter(),
    account: useAccount(),
    jobs: useJobs()
};

const App = () => {
    const { i18n } = useTranslation();
    let stopListening;

    useEffect(() => {
        document.onkeydown = (event) => {
            if (event.altKey && event.key === "l") {
                changeLanguage();
            }
        }
        stopListening = history.listen(() => setTimeout(() => window.scrollTo({ top: 0 }), 50));

        return () => {
            stopListening();
        }

    }, []);

    function changeLanguage() {
        switch (i18n.language) {
            case "en":
                i18n.changeLanguage("hi");
                break;
            case "hi":
                i18n.changeLanguage("th");
                break;
            case "my":
                i18n.changeLanguage("my");
                break;
            case "cn":
                i18n.changeLanguage("cn");
                break;
            case "th":
                i18n.changeLanguage("en");
                break;
            default:
                i18n.changeLanguage("en");
                break;
        }
    }

    return (
        <Router history={history}>
            <AppState containers={containers}>
                <ToastProvider className="toast-container" toastClassName="plastx-toast">
                    <AccountProvider>
                        <PlastXProvider>
                            <Switch>
                                <Route exact path="/user/my-profile" component={mustBeLoggedIn(Profile)} />
                                <Route exact path="/user/edit-profile" component={mustBeLoggedIn(EditProfile)} />
                                <Route exact path="/user/my-qr-code" component={mustBeLoggedIn(QrCode)} />
                                <Route path="/user" component={AccountWrapper} />
                                <Route path="/account/impersonate" exact component={Impersonate} />
                                <Route path="/account/unimpersonate" exact component={Unimpersonate} />
                                <Route path="/account/resetPassword" component={ForgotPassword} />
                                <Route path="/jobs/job-details/:jobId" component={mustBeLoggedIn(JobDetails)} />
                                <Route path="/jobs/job-commit/:jobId" component={mustBeLoggedIn(JobCommit)} />
                                <Route path="/jobs/job-delivery/:jobId" component={mustBeLoggedIn(JobDelivery)} />
                                <Route path="/jobs" component={mustBeLoggedIn(Jobs)} />
                                <Route path="/hubinqualitycheck" component={HubInQualityCheck} />
                                <Route path="/huboutqualitycheck" component={HubOutQualityCheck} />
                                <Route path="/processorqualitycheck" component={ProcessorQualityCheck} />
                                <Route path="/qualitycheck/:jobId" component={mustBeLoggedIn(CollectorQualityCheck)} />
                                <Route path="/" exact component={mustBeLoggedIn(Home)} />
                                <Route component={Notfound} />
                            </Switch>
                        </PlastXProvider>
                    </AccountProvider>
                </ToastProvider>
            </AppState>
        </Router>
    );
};

export default App;
